import { UrlParams } from '@provision/portal-routes';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useCustomViews } from 'src/graphql/entities/custom-view';
import { EntityNames } from 'src/graphql/types';
import { useRouteParams } from 'src/utils/routing';

export const useCustomView = (entityName: EntityNames) => {
  const location = useLocation();

  const routeParams = useRouteParams(UrlParams.customViewId);

  const customViewId =
    routeParams.customViewId ?? (location.state as { customViewId?: string })?.customViewId;

  const { customViews } = useCustomViews({
    entity: entityName,
  });

  const customView = useMemo(
    () => (customViewId ? customViews.find((i) => i.customViewId === customViewId) : null),
    [customViews, customViewId],
  );

  return customView;
};
